import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import { loadable } from 'jotai/utils'

import { VIEW_TYPES } from '../utils/utility'
// 服务器版本查询 atom（异步）
const serverVersionQueryAtom = atom(async (get, { signal }) => {
  try {
    const res = await fetch('/api/version', { signal })
    const data = await res.json()
    return data?.version || ''
  } catch {
    return ''
  }
})

// 服务器版本可加载 atom（包装异步查询，提供加载状态）
export const serverVersionLoadableAtom = loadable(serverVersionQueryAtom)

export const viewTypeAtom = atom(VIEW_TYPES.USER)

export const locationAtom = atom(null)

export const selectedChatRoomIdAtom = atom((get) => {
  const loc = get(locationAtom)
  if (!loc) return null

  if (!loc.pathname.includes('chat')) return null

  return new URLSearchParams(loc.search).get('roomId')
})

export const isChatPageAtom = atom((get) => {
  return Boolean(get(selectedChatRoomIdAtom))
})

export const isMobileAtom = atom(false)

export const fullScreenAtom = atom((get) => {
  return get(isChatPageAtom) && get(isMobileAtom)
})

export const isAppContentScrolledDownAtom = atom(false)

export const hasSeenTooltipAtom = atomWithStorage('showInstructorToolTip', false)
